import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, ShoppingCart } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Founder', path: '/founder' },
    { name: 'Courses', path: '/courses' },
    { name: 'Lesson Plans', path: '/lesson-plans' },
    { name: 'Gen Z Programs', path: '/genz-programs' },
    { name: 'Settings', path: '/settings' }
  ];

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50" data-testid="navbar">
      <div className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_learntree-edu/artifacts/ypj5kq54_Tinkred-Logo.jpeg" 
              alt="Tinkred Logo" 
              className="h-10 w-10 object-contain"
            />
            <div className="text-3xl font-bold bg-gradient-to-r from-teal-500 via-blue-500 to-purple-500 bg-clip-text text-transparent">Tinkred</div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                className="text-gray-700 hover:bg-gradient-to-r hover:from-teal-500 hover:via-blue-500 hover:to-purple-500 hover:bg-clip-text hover:text-transparent font-medium transition-colors"
              >
                {link.name}
              </Link>
            ))}
            <Button 
              data-testid="cart-btn"
              onClick={() => navigate('/checkout')}
              className="bg-gradient-to-r from-teal-600 to-purple-600 hover:from-teal-700 hover:to-purple-700 text-white rounded-full px-6"
            >
              <ShoppingCart className="w-5 h-5" />
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            className="lg:hidden text-gray-700"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block text-gray-700 hover:bg-gradient-to-r hover:from-teal-500 hover:via-blue-500 hover:to-purple-500 hover:bg-clip-text hover:text-transparent font-medium py-2"
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Button 
              onClick={() => {
                navigate('/checkout');
                setIsOpen(false);
              }}
              className="w-full bg-gradient-to-r from-teal-600 to-purple-600 hover:from-teal-700 hover:to-purple-700 text-white rounded-full"
            >
              Cart <ShoppingCart className="ml-2 w-5 h-5" />
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;